export const SET_AUTH = 'SET_AUTH'
export const SET_NEXT_ROUTE = 'SET_NEXT_ROUTE'
export const SET_FROM_ROUTE = 'SET_FROM_ROUTE'
export const SET_LOADING = 'SET_LOADING'
export const RESET_AUTH = 'RESET_AUTH'
